"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPercentOfRange = getPercentOfRange;
/**
 * Для значения input и диапазона значений left - right возвращает процент значения от диапазона значений
 * @example Для диапазона 0-4 и значения 2, результатом будет 50%
 * */
function getPercentOfRange(input, left, right) {
  return (input - left) / (right - left);
}